module.exports = __webpack_public_path__ + "media/images/castlerock/hero-image-aab98c4d6555b24aab5b69f682fb4b23.jpg";